import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, unref as _unref } from "vue"

const _hoisted_1 = { class: "chat-tile chat-item row items-center" }
const _hoisted_2 = { class: "chat-item__container col" }
const _hoisted_3 = { class: "chat-item__title--container row" }
const _hoisted_4 = { class: "chat-item__title col q-mb-xs" }
const _hoisted_5 = {
  key: 0,
  class: "col-1 q-px-md"
}
const _hoisted_6 = { class: "font-caption text-brand-grey" }
const _hoisted_7 = {
  key: 1,
  class: "absolute-bottom-right q-mb-xs",
  style: {"margin-right":"22px"}
}
const _hoisted_8 = { class: "col-xs-1 q-px-md" }
const _hoisted_9 = {
  key: 0,
  class: "chat-item__message font-caption"
}
const _hoisted_10 = { class: "author" }
const _hoisted_11 = { class: "last-message text-brand-grey" }
const _hoisted_12 = {
  key: 1,
  class: "chat-item__message font-caption"
}

import { convertUTCToLocal } from '@packages/toolbox/dist/utils/datetime';
import { getFirstLettersFromText } from '@packages/toolbox/dist/utils/string';
import { generateFIOInitials } from '@packages/toolbox/dist/utils/user';
import { computed, ref } from 'vue';

import { DELAY_TOOLTIP } from 'SharedDir/constants/common';
import { Chats } from 'SharedDir/declarations/chats';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'Chat' },
  __name: 'Chat',
  props: {
    data: {}
  },
  emits: ["pin", "mute"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emits = __emit;
const pinned = ref(props.data.isFavorite);
const mute = ref(props.data.isMute);
const lastMessage = computed(() => {
  const [m] = props.data.messages || [];
  return m;
});
const lastMessageTime = computed(() => {
  if (lastMessage.value) {
    const date = convertUTCToLocal(lastMessage.value.createdAt);
    let hours: string | number = date.getHours();
    let minutes: string | number = date.getMinutes();
    if (Number(hours) < 10) {
      hours = `0${hours}`;
    }
    if (Number(minutes) < 10) {
      minutes = `0${minutes}`;
    }
    return `${hours}:${minutes}`;
  }
  return '';
});
const lastMessageAuthor = computed(() => {
  if (lastMessage.value) {
    const u = lastMessage.value.user;
    return generateFIOInitials(u.lastName, u.firstName, u.middleName);
  }
  return '';
});
const chatName = computed(() => props.data.name || 'Безымянный');

const hasUnreadMessages = computed(() => props.data.unreadMessages > 0);

const unreadCount = computed(() => {
  return props.data.unreadMessages > 9 ? '9+' : props.data.unreadMessages;
});

const avatarName = computed(() => {
  const pureChatName: string = chatName.value
    .replace(/Заявление №\d+/, '')
    .replace('(', '')
    .replace(')', '');
  const name = getFirstLettersFromText(pureChatName);
  return name.length > 2 ? name.substring(0, 2) : name;
});

const muteData = computed(() => {
  return {
    icon: mute.value ? 'app:notifications' : 'app:notifications-off',
    tooltip: mute.value ? 'Включить уведомления' : 'Отключить уведомления',
  };
});

function toggleMute() {
  mute.value = !mute.value;
  emits('mute');
}

function togglePin() {
  pinned.value = !pinned.value;
  emits('pin');
}

return (_ctx: any,_cache: any) => {
  const _component_s_icon = _resolveComponent("s-icon")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        class: _normalizeClass(["chat-tile__avatar chat-item__avatar", { 'chat-item__avatar--bookmark': !pinned.value }])
      }, [
        _createVNode(_component_s_icon, {
          class: "bookmark",
          name: "app:flag-active",
          size: "small",
          color: "primary",
          onClick: _withModifiers(togglePin, ["stop"])
        }),
        _createTextVNode(" " + _toDisplayString(avatarName.value), 1)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString(chatName.value), 1),
          (mute.value)
            ? (_openBlock(), _createBlock(_component_s_icon, {
                key: 0,
                name: "las la-volume-off",
                size: "small",
                color: "dark"
              }))
            : _createCommentVNode("", true)
        ]),
        (lastMessage.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(lastMessageTime.value), 1)
            ]))
          : _createCommentVNode("", true),
        (hasUnreadMessages.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_q_badge, {
                color: "grey",
                rounded: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(unreadCount.value), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: _normalizeClass({ 'chat-item__mute': !mute.value })
          }, [
            _createVNode(_component_s_icon, {
              class: "pressed",
              name: muteData.value.icon,
              size: "small",
              color: "info",
              onClick: _withModifiers(toggleMute, ["stop"])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, {
                  "content-class": "s-tooltip",
                  delay: _unref(DELAY_TOOLTIP)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(muteData.value.tooltip), 1)
                  ]),
                  _: 1
                }, 8, ["delay"])
              ]),
              _: 1
            }, 8, ["name"])
          ], 2)
        ])
      ]),
      (lastMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(lastMessageAuthor.value) + ":", 1),
            _cache[0] || (_cache[0] = _createTextVNode("  ")),
            _createElementVNode("span", _hoisted_11, _toDisplayString(lastMessage.value.message), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[1] || (_cache[1] = [
            _createElementVNode("span", { class: "last-message text-brand-grey" }, "Нет сообщений", -1)
          ])))
    ])
  ]))
}
}

})